'use client'

import { ButtonIconTransparent } from 'fukku/Button/Icon/Transparent'
import { IconCloseMedium } from 'icons/components/IconCloseMedium'
import { useProductCardContext } from 'product-card/hooks/useProductCardContext'
import type { Product } from 'product/types'

import styles from '../SizeSheetIcon/SizeSheetIcon.module.scss'

type RemoveFromBagIconProps = { product: Product }

//TODO: use correct Icon (Minus)

export const RemoveFromBagIcon = ({ product }: RemoveFromBagIconProps) => {
	const { setIsProductInBag } = useProductCardContext()
	const onClick = () => {
		// TODO: remove from cart logic
		setIsProductInBag(false)
	}
	return (
		<ButtonIconTransparent
			key={product.id}
			className={styles.button}
			onClick={onClick}
			data-testid='productCard.sizeSheetIconButton' // TODO: correct data-testid
		>
			<IconCloseMedium className={styles.icon} />
		</ButtonIconTransparent>
	)
}
